import { Swiper } from 'swiper';
import { A11y, Navigation } from 'swiper/modules';

const featuredEventsBlocks = document.querySelectorAll(
	'.block-featured-events'
);

if (featuredEventsBlocks.length > 0) {
	featuredEventsBlocks.forEach((block) => {
		const slider = block.querySelector('.swiper');
		const slides = block.querySelectorAll('.swiper-slide');
		const prevButton = block.querySelector('.swiper-button-prev');
		const nextButton = block.querySelector('.swiper-button-next');

		new Swiper(slider, {
			modules: [A11y, Navigation],
			slidesPerView: 1,
			spaceBetween: 20,
			navigation: {
				prevEl: prevButton,
				nextEl: nextButton,
			},
			a11y: {
				itemRoleDescriptionMessage: 'slide',
			},
			breakpoints: {
				768: {
					slidesPerView: 2,
					centeredSlides: true,
					loop: true,
				},
				992: {
					slidesPerView: 3,
					spaceBetween: 8,
					centeredSlides: true,
					loop: true,
					loopAdditionalSlides: 1,
				},
			},
		});
	});
}
